import { HubConnectionBuilder, HttpTransportType, JsonHubProtocol, LogLevel, HubConnection, HubConnectionState } from "@aspnet/signalr";
import keycloak from 'utils/keycloak';

const base_url = process.env.REACT_APP_API_BASE_URL;
let hubConnection : HubConnection | undefined = undefined;

export function useHubNotification() {
    if (hubConnection) return hubConnection;

    hubConnection = new HubConnectionBuilder()
        .withUrl(`${base_url}/notify`, {
            accessTokenFactory: () => (keycloak.token ? keycloak.token : ''),
            skipNegotiation: true,
            transport: HttpTransportType.WebSockets,
        })
        .withHubProtocol(new JsonHubProtocol())
        .configureLogging(LogLevel.Error)
        .build();

    hubConnection.keepAliveIntervalInMilliseconds = 500;
    hubConnection.serverTimeoutInMilliseconds = 4 * 60000;
    return hubConnection;
}